import { ContentTypeFilterClause, MixedContentItemDefinition } from './ContentDefinitionsTypes';
import { Messages } from '../../../codegen/Localize';
import { DataConnectionContentType } from '../ContentTypes';
import { getDataConnectionDefaultFilters } from './getDefaultFilters';
import { DataconnectionCard } from '../../../app/spaces/CardView/DataconnectionCard';
import { ServerFilterClauses } from '../../helpers/ServerFilterClauses';
import { ServiceLocator } from '../../../app/ServiceLocator';
import { DataConnections } from '../../resources/DataConnections';

export const DataConnectionDefinition: MixedContentItemDefinition = {
  itemType: 'dataconnection',
  pluralName: Messages.connections,
  emptyStateMessage: Messages.connectionsEmptyMessage,
  siteFilterByTypeDropdownName: () => '', // connections can be viewed as mixed content, but not as top-level content
  contentFilterKeys: DataConnectionContentType.filterKeys,
  defaultFilters: getDataConnectionDefaultFilters,
  cardComponent: DataconnectionCard,
  listViewIconUrl: '', // we don't display an icon for data connections
  filterClause: ServerFilterClauses.ContentType(['dataconnection']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    const dataConnectionsResource = ServiceLocator.get<DataConnections>('DataConnections');
    return dataConnectionsResource.all();
  },
  fieldValueResourceType: 'dataConnection',
  getContentInfo: () => {
    throw new Error('getContentInfo is not implemented for dataconnection');
  },
  supportedDisplayModes: ['list', 'thumbnail'],
};
